var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "address-form" }, [
    _c(
      "h2",
      { staticClass: "title" },
      [
        !_vm.address.name
          ? [_vm._v("\n      Добавить адрес доставки в городе\n    ")]
          : [_vm._v("\n      Редактировать адрес доставки в городе\n    ")],
        _c("span", { on: { click: _vm.chooseCity } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.innerAddress.cityName || _vm.USER_CITY.name) +
              "\n    "
          )
        ])
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "form" },
      [
        _c(
          "div",
          { staticClass: "input address" },
          [
            _c("ui-input", {
              attrs: {
                autofocus: !_vm.address.name,
                placeholder: "Например, «Офис» или «Дом»",
                label: "Название адреса*",
                clearable: ""
              },
              model: {
                value: _vm.innerAddress.name,
                callback: function($$v) {
                  _vm.$set(_vm.innerAddress, "name", $$v)
                },
                expression: "innerAddress.name"
              }
            })
          ],
          1
        ),
        _c("ui-metro", {
          staticClass: "input metro",
          attrs: { "city-id": _vm.innerAddress.cityId || _vm.USER_CITY.id },
          on: {
            change: function($event) {
              _vm.innerAddress.metroStationName = $event.name
            }
          },
          model: {
            value: _vm.innerAddress.metroStationId,
            callback: function($$v) {
              _vm.$set(_vm.innerAddress, "metroStationId", $$v)
            },
            expression: "innerAddress.metroStationId"
          }
        }),
        _c(
          "div",
          { staticClass: "input street" },
          [
            _c("ui-street-suggest", {
              attrs: {
                label: "Улица*",
                "city-id": _vm.innerAddress.cityId || _vm.USER_CITY.id
              },
              model: {
                value: _vm.street,
                callback: function($$v) {
                  _vm.street = $$v
                },
                expression: "street"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "input house" },
          [
            _c("ui-input", {
              attrs: {
                placeholder: "Номер дома",
                label: "Дом*",
                validate: "house",
                clearable: ""
              },
              model: {
                value: _vm.innerAddress.house,
                callback: function($$v) {
                  _vm.$set(_vm.innerAddress, "house", $$v)
                },
                expression: "innerAddress.house"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "input house-block half" },
          [
            _c("ui-input", {
              attrs: {
                placeholder: "Корпус",
                label: "Корпус",
                validate: "address_detail",
                clearable: ""
              },
              model: {
                value: _vm.innerAddress.houseBlock,
                callback: function($$v) {
                  _vm.$set(_vm.innerAddress, "houseBlock", $$v)
                },
                expression: "innerAddress.houseBlock"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "input building half" },
          [
            _c("ui-input", {
              attrs: {
                label: "Строение",
                placeholder: "Строение",
                validate: "address_detail",
                clearable: ""
              },
              model: {
                value: _vm.innerAddress.building,
                callback: function($$v) {
                  _vm.$set(_vm.innerAddress, "building", $$v)
                },
                expression: "innerAddress.building"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "input entrance half" },
          [
            _c("ui-input", {
              attrs: {
                label: "Подъезд",
                placeholder: "Подъезд",
                validate: "entrance",
                clearable: ""
              },
              model: {
                value: _vm.innerAddress.entrance,
                callback: function($$v) {
                  _vm.$set(_vm.innerAddress, "entrance", $$v)
                },
                expression: "innerAddress.entrance"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "input floor half" },
          [
            _c("ui-input", {
              attrs: {
                placeholder: "Этаж",
                label: "Этаж",
                validate: "floor",
                clearable: ""
              },
              model: {
                value: _vm.innerAddress.floor,
                callback: function($$v) {
                  _vm.$set(_vm.innerAddress, "floor", $$v)
                },
                expression: "innerAddress.floor"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "input apartment half" },
          [
            _c("ui-input", {
              attrs: {
                placeholder: "Квартира/ Офис",
                label: "Квартира/ Офис",
                validate: "address_detail",
                clearable: ""
              },
              model: {
                value: _vm.innerAddress.apartment,
                callback: function($$v) {
                  _vm.$set(_vm.innerAddress, "apartment", $$v)
                },
                expression: "innerAddress.apartment"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "input postcode half" },
          [
            _c("ui-input", {
              attrs: {
                placeholder: "Индекс",
                mask: "postalCode",
                label: "Индекс",
                validate: "postal_сode",
                clearable: ""
              },
              model: {
                value: _vm.innerAddress.postalCode,
                callback: function($$v) {
                  _vm.$set(_vm.innerAddress, "postalCode", $$v)
                },
                expression: "innerAddress.postalCode"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "bottom" },
          [
            _c("ui-textarea", {
              staticClass: "comment",
              attrs: { placeholder: "Комментарий к заказу" },
              model: {
                value: _vm.innerAddress.comment,
                callback: function($$v) {
                  _vm.$set(_vm.innerAddress, "comment", $$v)
                },
                expression: "innerAddress.comment"
              }
            }),
            _vm.changePrimary && !_vm.address.primary
              ? _c(
                  "div",
                  { staticClass: "checkbox" },
                  [
                    _c("ui-checkbox", {
                      attrs: { label: "Сделать основным адресом для доставки" },
                      model: {
                        value: _vm.innerAddress.primary,
                        callback: function($$v) {
                          _vm.$set(_vm.innerAddress, "primary", $$v)
                        },
                        expression: "innerAddress.primary"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c("ui-button", {
              staticClass: "button",
              attrs: {
                disabled: _vm.submitIsDisabled,
                loading: _vm.loading,
                text: "Сохранить"
              },
              on: { click: _vm.save }
            }),
            _c("ui-button", {
              staticClass: "button",
              attrs: { secondary: "", text: "Отменить" },
              on: {
                click: function($event) {
                  return _vm.$emit("on-close")
                }
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }